import type { InputSource, IntentDispatch } from './intent';

// Pointer scheme (works for mouse and touch): tapping the play surface shoots.
// Bound to the canvas only, so taps on HUD buttons (separate DOM) never fire a
// shot. This is the primary mobile control.
export class PointerInput implements InputSource {
  private dispatch: IntentDispatch | null = null;

  constructor(private readonly target: HTMLElement) {}

  private readonly onPointerDown = (e: PointerEvent): void => {
    if (!this.dispatch) return;
    e.preventDefault();
    this.dispatch({ type: 'shoot' });
  };

  attach(dispatch: IntentDispatch): void {
    this.dispatch = dispatch;
    this.target.addEventListener('pointerdown', this.onPointerDown);
    // Block double-tap zoom / long-press selection on touch devices.
    this.target.style.touchAction = 'none';
  }

  detach(): void {
    this.target.removeEventListener('pointerdown', this.onPointerDown);
    this.dispatch = null;
  }
}
